/* eslint-disable no-restricted-syntax */

export const enum EstadoFinanciero {
    BORRADOR = 'borrador',
    PENDIENTE = 'pendiente',
    APROBADO = 'aprobado',
    RECHAZADO = 'rechazado',
    ANULADO = 'anulado',
}

export const enum TipoMovimientoFinanciero {
    DEPOSITO = 'deposito',
    NOTA_CREDITO = 'nota_credito',
    CHEQUE = 'cheque',
    NOTA_DEBITO = 'nota_debito',
    TRANSFERENCIA = 'transferencia',
}
